export interface WebSocketMessage {
  type: string;
  data?: any;
  messageId?: string;
  requireAck?: boolean;
  requestData?: {
    command?: string;
    action?: string;
    component_id?: string;
    screen_id?: string;
  };
}

export interface AuthorizePayload {
  groupIdentifier: string;
  sessionIdentifier: string;
  isAdmin: boolean;
}

export interface WebSocketConfig {
  deviceId: string;
  sessionId: string;
  onPageUpdate: (message: WebSocketMessage) => void;
  onConnect?: () => void;
  onDisconnect?: (reason?: string) => void;
  onError?: (error: Error) => void;
}

export type WebSocketProviderType = 'socket.io' | 'native';

export abstract class WebSocketProvider {
  protected config: WebSocketConfig;
  protected connected: boolean = false;

  constructor(config: WebSocketConfig) {
    this.config = config;
  }

  abstract connect(): void;
  abstract disconnect(): void;
  abstract isConnected(): boolean;
  abstract sendAck(messageId: string): void;
  abstract setManualDisconnect(value: boolean): void;
}
